// generated on ti 17.5.2022 13.30.04 +0300
export const appVersion = '0.8.93';
